import React from 'react';

import { CheckIcon, ClockIcon } from 'lucide-react';

import { Badge } from '@/components/shadcn/ui/badge';
import { cn } from '@/utils';

interface UtxoStatusProps {
  isConfirmed: boolean;
  className?: string;
}

export const UtxoStatus: React.FC<UtxoStatusProps> = ({ isConfirmed, className }) => {
  return (
    <Badge variant={isConfirmed ? 'success' : 'pending'} className={cn('flex items-center gap-0.5', className)}>
      {isConfirmed ? (
        <>
          <CheckIcon className="size-2.5" /> Confirmed
        </>
      ) : (
        <>
          <ClockIcon className="size-2.5" /> Unconfirmed
        </>
      )}
    </Badge>
  );
};
